import { render, staticRenderFns } from "./coderule.vue?vue&type=template&id=edca0eec&scoped=true&"
import script from "./coderule.vue?vue&type=script&lang=js&"
export * from "./coderule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edca0eec",
  null
  
)

export default component.exports